<template>
  <div class="DlFinish">
    <section-header heading="2" ja="ダウンロードに成功しました"/>
    <div class="text-area">
      <template v-if="download">保存できたプリクラは「アルバム」に追加されます</template>
      <template v-else>
        撮影したプリクラは、アップロードが完了したら「アルバム」に追加されるよ！しばらく時間をおいてから アルバムで確認してね！<br>
        ※もし、1日以上経過しても「アルバム」に追加されなかったら、お問い合わせをお願いします
      </template>
    </div>
    <normal-btn @click="onAlbum">アルバム</normal-btn>
    <section-header heading="2" ja="アプリ版「プリクラON」の紹介"/>
    <div class="text-area">
        アプリ版「プリクラON」だとこんな機能も使えるよ！<br>
        ・らくがき/背景/メイクのON/OFF<br>
        ・リップ/チークの編集<br>
        ・ARプリクラ<br>
        ・特別なプリクラ「プリもっと」
    </div>
    <div class="text-area">
        アプリは以下のリンクからダウンロードしてね♪
    </div>
    <div class="storeLink">
      <a href="https://apps.apple.com/jp/app/%E3%83%97%E3%83%AA%E3%82%AF%E3%83%A9on/id1491707486?l=en&amp;itsct=apps_box&amp;itscg=30200" style="display: inline-block; overflow: hidden; border-radius: 13px; width: 160px; height: 71px; padding: 11px; vertical-align: top;"><img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/ja-JP?size=250x83&amp;releaseDate=1601942400&h=fd01c540f4b59e9b14385d0f0471c6f8" alt="Download on the App Store" style="border-radius: 13px; width: 140px; height: 49px;"></a>
      <a href='https://play.google.com/store/apps/details?id=com.sega.puri&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img alt='Google Play で手に入れよう' src='https://play.google.com/intl/en_us/badges/static/images/badges/ja_badge_web_generic.png' style="height: 70px;" /></a>
    </div>
  </div>
</template>

<script>
import Protobuf from '../mixins/protobuf'
import MaintenanceCheck from '../mixins/maintenancecheck';
import SectionHeader from '../components/SectionHeader'
import NormalBtn from '../components/NormalBtn'

export default {
  name: "DlFinish",
  components: {
    NormalBtn,
    SectionHeader
  },
  mixins: [Protobuf,MaintenanceCheck],
  props: {
    download: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isLogin() {
      return this.$store.getters.isLogin
    },
  },
  methods: {
    onHome() {
        this.$router.push('/')
    },
    onAlbum() {
      this.$router.push('/Album')
    }
  },
  mounted(){
    this.maintenanceCheck();
  },
}
</script>

<style scoped>
.text-area {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
}
.storeLink {
  margin: 10px 0;
  text-align: center;
}
</style>
